import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AREA_PATHS, DashboardArea, canUseArea, homeArea, rememberArea, storedUser } from '../utils/dashboard-access';

// Logged in and allowed to use this dashboard; otherwise sends the user to their own home (or login).
export function dashboardAreaGuard(area: DashboardArea): CanActivateFn {
  return () => {
    const router = inject(Router);
    const user = storedUser();
    if (user && canUseArea(user, area)) {
      rememberArea(user, area);
      return true;
    }
    const home = user ? homeArea(user) : null;
    return router.parseUrl(home ? AREA_PATHS[home] : '/auth');
  };
}
